<template>
  <div v-if="order">
    <v-card class="mb-3" elevation="0">
      <v-card-title>Commande de "{{order.user.account.name}}"</v-card-title>
    </v-card>

    <v-card class="mb-3">
      <v-card-title>Client</v-card-title>
      <v-card-text>asdasd</v-card-text>
    </v-card>

    <v-card class="mb-3">
      <v-tabs v-model="tabs">
        <v-tab>Commande originale</v-tab>
        <v-tab v-if="finished">Délivrables</v-tab>
        <v-tab>Actions</v-tab>
      </v-tabs>
      <v-tabs-items v-model="tabs">
        <v-tab-item>
          <v-card elevation="0" class="mb-3">
            <v-card-text>
              <v-container fluid>
                <v-row v-for="step in order.service.steps" :key="step.id">
                  <field-group :blocks="step.blocks" />
                </v-row>
              </v-container>
            </v-card-text>
          </v-card>
        </v-tab-item>
        <v-tab-item v-if="finished">
          <v-card class="elevation-0">
            <v-card-title>Fichiers</v-card-title>
            <v-card-text>
              <div v-for="file in order.files" :key="file.id">
                <v-dialog v-model="zoom[file.id]">
                  <template v-slot:activator="{on}">
                    <img v-on="on" :src="$assets.url(file.url)" height="150" width="auto" />
                  </template>
                  <v-card>
                    <v-card-text>
                      <img :src="$assets.url(file.url)" height="auto" width="auto" />
                    </v-card-text>
                  </v-card>
                </v-dialog>
              </div>
            </v-card-text>
          </v-card>
        </v-tab-item>
        <v-tab-item>
          <component :is="include" :order="order" @update="initialize()" />
        </v-tab-item>
      </v-tabs-items>
    </v-card>
  </div>
</template>

<script>
import FieldGroup from "@/components/order/FieldGroup.vue";
import BBInclude from "@/components/order/BBInclude.vue";
import MeeroInclude from "@/components/order/MeeroInclude.vue";
import FileInclude from "@/components/order/FileInclude.vue";
import OfferInclude from "@/components/order/OfferInclude.vue";
import RdvInclude from "@/components/order/RdvInclude.vue";

export default {
  components: {
    FieldGroup,
    BBInclude,
    FileInclude,
    OfferInclude,
    RdvInclude,
    MeeroInclude
  },
  data: function() {
    return {
      tabs: null,
      orderId: null,
      order: null,
      zoom: {}
    };
  },
  computed: {
    include() {
      if (this.order.service.api && this.order.service.api == "bb") {
        return "BBInclude";
      }
      if (this.order.service.api && this.order.service.api == "meero") {
        return "MeeroInclude";
      }
      if (this.order.service.type_id == "rdv") {
        return "RdvInclude";
      }
      if (this.order.service.type_id == "file") {
        return "FileInclude";
      }
      if (this.order.service.type_id == "offer") {
        return "OfferInclude";
      }
      return "";
    },
    finished() {
      return (
        ["delivered", "toBeReviewed"].includes(this.order.status) &&
        this.order.files.length > 0
      );
    }
  },
  mounted: function() {
    this.initialize();
  },
  methods: {
    initialize() {
      if (this.$route.params.id) {
        this.orderId = parseInt(this.$route.params.id);
        this.getorder();
      } else {
        this.$router.push("/orders");
      }
    },
    getorder() {
      this.$store.dispatch("order/get", this.orderId).then(() => {
        this.order = this.$store.getters["order/order"];
      });
    }
  }
};
</script>

<style>
</style>